import { VolumeX } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

interface DirectVideoPlayerProps {
  src: string;
  poster?: string | null;
}

export function DirectVideoPlayer({ src, poster }: DirectVideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;
    video.play().catch(() => {});
  }, []);

  const handleUnmute = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = false;
    setIsMuted(false);
    video.play().catch(() => {});
  };

  return (
    <div className="relative aspect-video w-full overflow-hidden border-2 border-primary/20 bg-black">
      <video
        ref={videoRef}
        src={src}
        poster={poster ?? undefined}
        controls
        autoPlay
        muted
        playsInline
        preload="metadata"
        className="h-full w-full"
        onVolumeChange={(e) => setIsMuted(e.currentTarget.muted)}
      />
      {isMuted && (
        <button
          type="button"
          onClick={handleUnmute}
          className="absolute inset-0 flex items-center justify-center bg-black/60 transition-opacity hover:bg-black/70"
          aria-label="Unmute video"
        >
          <div className="flex flex-col items-center gap-3 rounded-lg bg-primary px-8 py-6 text-background transition-transform hover:scale-105">
            <VolumeX className="h-12 w-12" />
            <span className="font-title text-lg">
              Toca para activar el audio
            </span>
          </div>
        </button>
      )}
    </div>
  );
}
